require('initializers/gettext').default(__TRANSLATIONS__.gettext.it); // eslint-disable-line no-undef
require('initializers/i18n').default('it', __TRANSLATIONS__.i18n.it); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/it');
require('jquery-ui/ui/i18n/datepicker-it');
require('moment/locale/it');
require('dayjs/locale/it');
